import React, { Component } from 'react';
import './AttendeesTable.css';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import { HeaderSortComponent } from '../../../../../Scss/Custom/ReactTable/HeaderSortComponent';
import { getAttendeesData, getInverseOrder, timeFormatterFromMilliSecToHrMinSec } from '../../../../../Utils/TableUtil';
import Pagination from '@getgo/chameleon-react/dist/Pagination';
import PropTypes from 'prop-types';
import SimpleSearchBox from '../../../../../Components/SearchBox/SimpleSearchBox';
import { getAttendeesTableColumnOptions } from '../../../../../Components/CheckedMenu/CheckedMenuItemsHelper';
import CheckedMenu from '../../../../../Components/CheckedMenu/CheckedMenu';
import { actions } from '../../../../../Reducks/SessionAttendees';
import { SESSION_DETAILS, ATTENDEES_SEARCH } from '../../../../../Telemetry/Mixpanel/Constants/mixpanelConstants';
import { toggleElement } from '../../../../../Utils/ArrayUtils';
import { AttendeesTableColumns } from '../../../../../Utils/Constants';

export class AttendeesTable extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };
  static propTypes = {
    session_attendees: PropTypes.object,
    sessionKey: PropTypes.any,
    requestAttendees: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      visibleColumns: [
        AttendeesTableColumns.INTEREST_RATING,
        AttendeesTableColumns.TIME_IN_SESSION,
        AttendeesTableColumns.CERTIFICATE_SENT,
        AttendeesTableColumns.POLL_ANSWERED_COUNT,
        AttendeesTableColumns.SURVEY_QUESTION_ANSWERED_COUNT,
        AttendeesTableColumns.QUESTION_COUNT
      ],
      currentPage: 1
    };
  }

  onClickHandler = updateId =>
    this.setState(prevState => ({ visibleColumns: toggleElement(updateId, prevState.visibleColumns) }));

  render() {
    const { fetching, attendees, page } = this.props.session_attendees;
    const { currentPage } = this.state;
    const mixpanelData = {
      action: SESSION_DETAILS,
      searchType: ATTENDEES_SEARCH
    };
    const { t } = this.context;
    const { isBig } = this.props;
    const detailsMenu = getAttendeesTableColumnOptions().map(item => {
      return {
        onClick: () => this.onClickHandler(item.id),
        text: item.title,
        id: item.id,
        checked: this.state.visibleColumns.includes(item.id)
      };
    });
    return (
      <div className="attendeesTableSection">
        <div className="searchRow">
          <SimpleSearchBox
            searchString={this.props.session_attendees.filter.textSearch}
            placeHolder={t('sessionDetails.searchAttendees')}
            onSearchInputChange={this.handleSearch}
            mixpanelData={mixpanelData}
          />
          <CheckedMenu
            menuKey="manageColumns"
            detailsMenu={detailsMenu}
            buttonName={t('sessionDetails.manageColumns')}
            isBig={isBig}
          />
        </div>
        {attendees && (
          <React.Fragment>
            {this.getAttendeesTable(attendees, fetching)}
            <div className="pagination">
              <Pagination
                key="attendee-table-pagination"
                pageIndex={currentPage}
                lastPage={Math.ceil(page.totalElements / page.size)}
                previousDisabled={currentPage === 1}
                nextDisabled={currentPage === Math.ceil(page.totalElements / page.size)}
                onNextSelected={() => this.fetchMoreAttendees({ pageNumber: currentPage + 1 })}
                onPreviousSelected={() => this.fetchMoreAttendees({ pageNumber: currentPage - 1 })}
                onPageSelected={page => this.fetchMoreAttendees({ pageNumber: page })}
              />
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }

  fetchMoreAttendees(options = {}) {
    const { requestAttendees, sessionKey, session_attendees } = this.props;
    const {
      pageNumber = this.state.currentPage,
      textSearch = session_attendees.filter.textSearch,
      sortBy = session_attendees.sort.sortBy,
      sortOrder = session_attendees.sort.sortOrder
    } = options;
    this.setState({ currentPage: pageNumber }, () =>
      requestAttendees(sessionKey, pageNumber - 1, { textSearch }, { sortOrder, sortBy })
    );
  }
  handleSearch = value => {
    if (value !== null) {
      this.fetchMoreAttendees({ pageNumber: 1, textSearch: value });
    }
  };

  getAttendeesTable = (attendees, fetching) => {
    return (
      <ReactTable
        keyField="registrantKey"
        data={getAttendeesData(attendees)}
        columns={this.getAttendeesColumns()}
        loading={fetching}
        defaultPageSize={50}
        minRows={5}
        style={{ height: '270px' }}
        showPagination={false}
        className="-highlight"
        sortable={false}
      />
    );
  };

  emailCellFormatter = ({ original }) => <a href={`mailto:${original.email}`}>{original.email}</a>;

  getAttendeesColumns = () => {
    const { t } = this.context;
    const { session_attendees } = this.props;
    const sortBy = session_attendees.sort.sortBy;
    const sortOrder = session_attendees.sort.sortOrder;
    return [
      {
        accessor: 'interestRating',
        Header: (
          <HeaderSortComponent
            headerTitle={t('sessionDetails.interestRating')}
            onClick={() => {
              this.fetchMoreAttendees({
                sortBy: AttendeesTableColumns.INTEREST_RATING,
                sortOrder: getInverseOrder(sortOrder),
                pageNumber: 1
              });
            }}
            sortOrderOverride={sortBy === AttendeesTableColumns.INTEREST_RATING ? sortOrder : null}
          />
        ),
        show: this.state.visibleColumns.includes(AttendeesTableColumns.INTEREST_RATING),
        style: { paddingLeft: '40px' },
        headerStyle: { paddingLeft: '40px' },
        minWidth: 200
      },
      {
        accessor: 'firstName',
        Header: (
          <HeaderSortComponent
            headerTitle={t('sessionDetails.firstName')}
            onClick={() => {
              this.fetchMoreAttendees({
                sortBy: AttendeesTableColumns.GIVEN_NAME,
                sortOrder: getInverseOrder(sortOrder),
                pageNumber: 1
              });
            }}
            sortOrderOverride={sortBy === AttendeesTableColumns.GIVEN_NAME ? sortOrder : null}
          />
        ),
        style: { paddingLeft: '40px' },
        headerStyle: { paddingLeft: '40px' },
        minWidth: 200
      },
      {
        accessor: 'lastName',
        Header: (
          <HeaderSortComponent
            headerTitle={t('sessionDetails.lastName')}
            onClick={() => {
              this.fetchMoreAttendees({
                sortBy: AttendeesTableColumns.SUR_NAME,
                sortOrder: getInverseOrder(sortOrder),
                pageNumber: 1
              });
            }}
            sortOrderOverride={sortBy === AttendeesTableColumns.SUR_NAME ? sortOrder : null}
          />
        ),
        style: { paddingLeft: '40px' },
        headerStyle: { paddingLeft: '40px' },
        minWidth: 200
      },
      {
        accessor: 'email',
        Header: (
          <HeaderSortComponent
            headerTitle={t('sessionDetails.email')}
            onClick={() => {
              this.fetchMoreAttendees({
                sortBy: AttendeesTableColumns.EMAIL,
                sortOrder: getInverseOrder(sortOrder),
                pageNumber: 1
              });
            }}
            sortOrderOverride={sortBy === AttendeesTableColumns.EMAIL ? sortOrder : null}
          />
        ),
        Cell: this.emailCellFormatter,
        minWidth: 200,
        style: { paddingLeft: '40px' },
        headerStyle: { paddingLeft: '40px' }
      },
      {
        accessor: 'timeInSession',
        Header: (
          <HeaderSortComponent
            headerTitle={t('sessionDetails.timeInSession')}
            onClick={() => {
              this.fetchMoreAttendees({
                sortBy: AttendeesTableColumns.TIME_IN_SESSION,
                sortOrder: getInverseOrder(sortOrder),
                pageNumber: 1
              });
            }}
            sortOrderOverride={sortBy === AttendeesTableColumns.TIME_IN_SESSION ? sortOrder : null}
          />
        ),
        Cell: timeFormatterFromMilliSecToHrMinSec,
        show: this.state.visibleColumns.includes(AttendeesTableColumns.TIME_IN_SESSION),
        minWidth: 200,
        style: { paddingLeft: '40px' },
        headerStyle: { paddingLeft: '40px' }
      },
      {
        accessor: 'certificateSent',
        Header: <HeaderSortComponent headerTitle={t('sessionDetails.certificateSentInFollowUpMail')} />,
        show: this.state.visibleColumns.includes(AttendeesTableColumns.CERTIFICATE_SENT),
        Cell: ({ value }) => String(value),
        minWidth: 200,
        style: { paddingLeft: '40px' },
        headerStyle: { paddingLeft: '40px' }
      },
      {
        accessor: 'pollResponseCount',
        Header: (
          <HeaderSortComponent
            headerTitle={t('sessionDetails.numberOfPollsAnswered')}
            onClick={() => {
              this.fetchMoreAttendees({
                sortBy: AttendeesTableColumns.POLL_ANSWERED_COUNT,
                sortOrder: getInverseOrder(sortOrder),
                pageNumber: 1
              });
            }}
            sortOrderOverride={sortBy === AttendeesTableColumns.POLL_ANSWERED_COUNT ? sortOrder : null}
          />
        ),
        show: this.state.visibleColumns.includes(AttendeesTableColumns.POLL_ANSWERED_COUNT),
        minWidth: 200,
        style: { paddingLeft: '40px' },
        headerStyle: { paddingLeft: '40px' }
      },
      {
        accessor: 'surveyQuestionAnsweredCount',
        Header: (
          <HeaderSortComponent
            headerTitle={t('sessionDetails.numberOfSurveyQuestionsAnswered')}
            onClick={() => {
              this.fetchMoreAttendees({
                sortBy: AttendeesTableColumns.SURVEY_QUESTION_ANSWERED_COUNT,
                sortOrder: getInverseOrder(sortOrder),
                pageNumber: 1
              });
            }}
            sortOrderOverride={sortBy === AttendeesTableColumns.SURVEY_QUESTION_ANSWERED_COUNT ? sortOrder : null}
          />
        ),
        show: this.state.visibleColumns.includes(AttendeesTableColumns.SURVEY_QUESTION_ANSWERED_COUNT),
        minWidth: 200,
        style: { paddingLeft: '40px' },
        headerStyle: { paddingLeft: '40px' }
      },
      {
        accessor: 'sessionQuestionCount',
        Header: (
          <HeaderSortComponent
            headerTitle={t('sessionDetails.numberOfQuestionsAsked')}
            onClick={() => {
              this.fetchMoreAttendees({
                sortBy: AttendeesTableColumns.QUESTION_COUNT,
                sortOrder: getInverseOrder(sortOrder),
                pageNumber: 1
              });
            }}
            sortOrderOverride={sortBy === AttendeesTableColumns.QUESTION_COUNT ? sortOrder : null}
          />
        ),
        show: this.state.visibleColumns.includes(AttendeesTableColumns.QUESTION_COUNT),
        minWidth: 200,
        style: { paddingLeft: '40px' },
        headerStyle: { paddingLeft: '40px' }
      }
    ];
  };
}

export default connect(
  state => ({
    session_attendees: state.reduced_session_attendees
  }),
  {
    requestAttendees: actions.getSessionAttendeesDetails
  }
)(AttendeesTable);



// WEBPACK FOOTER //
// ./src/GoToWebinar/Sessions/SessionDetails/Table/AttendeesTable/AttendeesTable.js